const personalInfoData = {
  name: 'Simon Chan',
  linkedIn: 'https://www.linkedin.com/in/simonmchan/',
  github: 'https://github.com/bluufish',
  angelList: 'https://angel.co/',
  email: 'mailto:simonmchan92@gmail.com',
  resume: 'https://www.dropbox.com/s/v459y8rpujph63f/Simon%20M.%20Chan%20Resume.pdf?dl=0'
};

export { personalInfoData };



// WEBPACK FOOTER //
// ./src/data/personalInfo.js